import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=17582c2a&scoped=true&lang=pug"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=17582c2a&prod&lang=scss&scoped=true"
import style1 from "./TheHeader.vue?vue&type=style&index=1&id=17582c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17582c2a",
  null
  
)

export default component.exports